import React from 'react';
import './details-item-link.scss';
import DefaultButton from '../../../default-button/default-button';
import { OpenIcon } from '../../../icons/icons';
import { DetailsItem } from '../details-item';
import { CopyButton } from '../../../copy-button/copy-button';
import { LinkTargetValue } from '../../../../../constants/common.constants';

interface IProps {
    title: string | JSX.Element;
    value: string;
}

const DetailsItemLink = (props: IProps) => {
    return (
        <DetailsItem title={props.title}>
            <a href={props.value} target={'blank'}>{props.value}</a>
            <div className='buttons-block buttons-block--narrow'>
                <DefaultButton modifier='slim'
                               text='Open'
                               icon={OpenIcon}
                               onClick={() => {
                                   window.open(props.value, LinkTargetValue.BLANK);
                               }}
                />
                <CopyButton copyValue={props.value} className='m-left-6px' />
            </div>
        </DetailsItem>
    );
};

export { DetailsItemLink };